import { Params } from '@angular/router';

export interface MfeContext {
	token: string;
	gateway: string;
	apikey: string;
	device?: string;
	segmento?: string;
	inputdata?: MfeInputdata;
}

export interface MfeInputdata {
	app: {
		unit: string;
		unitLabel: string;
	};
	navigation?: {
		queryParams?: Params;
		connectedToChassisRoute?: boolean;
	};
}

export enum MfeFeatureName {
	HOME = 'home',
	INTERNAL_USER = 'internal-user',
	SMA = 'sma',
	CUSTOMER = 'customer',
	REQUEST = 'request',
	GOP = 'gop',
	WIRE_TRANSFER = 'wire-transfer',
	SEND_STATEMENT = 'send-statement',
}

export interface MfeRouteConfig {
	label: string;
	icon: string;
	path: string;
}
